import { Component, Input } from '@angular/core';
import { IconName } from '../app-icon/icon.registry';

@Component({
  selector: 'app-filter-control',
  template: `
    <button class="filter-control" [class.filter-control--fixed]="width === 'fixed'">
      <app-icon *ngIf="leadingIcon" [name]="leadingIcon" [size]="15" [strokeWidth]="1.8"></app-icon>
      <span>{{ label }}</span>
      <app-icon class="filter-control__chevron" name="chevron-down" [size]="14" [strokeWidth]="2.2"></app-icon>
    </button>
  `
})
export class FilterControlComponent {
  @Input() label = '';
  @Input() leadingIcon: IconName | null = null;
  @Input() width: 'auto' | 'fixed' = 'auto';
}
